export default __webpack_public_path__ + "static/media/work-4.e3d81ac1.png";